/* pn-spdp-meta.js — ROUND 15 (Oct 31 2026). Saddle PDP: get a cold Meta visitor on a phone to Add to cart.
   Runs only on #pn-spdp. Additive: injects a trust line, profession match line, collapsed model picker (phones),
   sale deadline, three verified quotes, and an earlier sticky Add-to-cart. Reads window.PN6DATA (per-profession copy
   that already drives the lower page via ?for=) when present, falls back to static copy. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function after(ref, node) { if (ref && ref.parentNode) ref.parentNode.insertBefore(node, ref.nextSibling); return node; }
  var mq = window.matchMedia('(max-width: 720px)');

  ready(function () {
    var root = document.getElementById('pn-spdp'); if (!root) return;
    var bx = root.querySelector('.buy__grid > .bx'); if (!bx) return;
    var price = bx.querySelector('.bx__price'), rate = bx.querySelector('.bx__rate');
    var params = new URLSearchParams(location.search);
    var forKey = (params.get('for') || '').toLowerCase();
    var isUS = (window.Shopify && window.Shopify.country === 'US') || /(^|\.)pronorthmed\.com$/.test(location.hostname);

    /* 1. trust line under the price: the two questions a phone visitor has before scrolling */
    var trust = el('ul', 'pn-trust3');
    trust.innerHTML = '<li><b>Fits 21–34″ benches</b> — heights pre-set per model, no guesswork</li>' +
      '<li><b>30-day in-clinic trial</b> · 3-year warranty · real humans on the phone</li>' +
      (isUS ? '<li><b>Free 24h shipping</b> · no duties, no tariffs, no sales tax</li>' : '<li><b>Free shipping in 24h</b> from Vancouver · 1,800+ verified reviews</li>');
    var anchor = (rate && rate.parentNode === bx) ? rate : price;
    after(anchor, trust);

    /* 2. profession match: ?for=vet etc. from the ad → say so above the fold */
    var pn6 = function (cb, tries) { if (window.PN6DATA) return cb(window.PN6DATA); if (tries > 25) return cb(null); setTimeout(function () { pn6(cb, (tries || 0) + 1); }, 120); };
    pn6(function (D) {
      var d = D && D[forKey];
      if (d && d.eyebrow) {
        var f = el('div', 'pn-for', '<span class="pn-for__tag">' + d.eyebrow + '</span>' + (d.float ? '<q>' + d.float + '</q>' : ''));
        after(trust, f);
      }
      buildQuotes(D, d);
    });

    /* 3. phones: collapse the six-model grid behind one summary row; the full grid is one tap away */
    var lbl = bx.querySelector('.lbl'), models = bx.querySelector('#spdpModels'), selName = bx.querySelector('#spdpSelName'), selPrice = bx.querySelector('#spdpPrice');
    if (lbl && models && selName) {
      var pick = el('button', 'pn-pick');
      pick.type = 'button';
      pick.innerHTML = '<span class="pn-pick__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 14c0-4 3.5-6 8-6s8 2 8 6c0 1.5-1.5 2-4 2H8c-2.5 0-4-.5-4-2Z"/><path d="M12 16v5"/></svg></span>' +
        '<span class="pn-pick__body"><span class="pn-pick__k">Your model</span><span class="pn-pick__v"></span></span><span class="pn-pick__chg">Change</span>';
      bx.insertBefore(pick, lbl);
      var done = el('button', 'pn-pick-done', 'Done — keep this model'); done.type = 'button';
      after(models, done);
      var v = pick.querySelector('.pn-pick__v');
      var sync = function () { v.textContent = selName.textContent.replace(/\s+/g, ' ').trim() + (selPrice ? ' · ' + selPrice.textContent.trim() : ''); };
      sync();
      try { new MutationObserver(sync).observe(selName, { childList: true, characterData: true, subtree: true }); if (selPrice) new MutationObserver(sync).observe(selPrice, { childList: true, characterData: true, subtree: true }); } catch (e) {}
      var setCollapsed = function (on) { bx.classList.toggle('pn-collapsed', !!on); pick.querySelector('.pn-pick__chg').textContent = on ? 'Change' : 'Close'; };
      var apply = function () { setCollapsed(mq.matches); };
      apply(); mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
      pick.addEventListener('click', function () { setCollapsed(!bx.classList.contains('pn-collapsed')); if (!bx.classList.contains('pn-collapsed')) lbl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      done.addEventListener('click', function () { setCollapsed(true); pick.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      // choosing a leaf option (a sub-option, or a model with no sub-options) closes the grid again on phones
      models.addEventListener('click', function (ev) {
        if (!mq.matches) return;
        var sub = ev.target.closest('.subopt'), card = ev.target.closest('.mcard');
        if (sub || (card && !card.classList.contains('mcard--exp'))) setTimeout(function () { setCollapsed(true); pick.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 350);
      }, true); // capture: pn-spdp.js stops propagation on option clicks
    }

    /* 4. the deadline, next to the button where it does its job */
    var qty = bx.querySelector('.qtyrow');
    if (qty) after(qty, el('p', 'pn-deadline', '<b>50% warehouse-sale price ends Dec 31.</b> No Black Friday sale this year — this is it.'));

    /* 5. three verified quotes under the buy row, per profession when ?for= is set */
    function buildQuotes(D, d) {
      if (root.querySelector('.pn-quotes')) return;
      var items = (d && d.rev && d.rev.items) || (D && D.dental && D.dental.rev && D.dental.rev.items) || [
        { p: '“Traditional chairs forced me into twisted, rounded positions. This reopened my hips and aligned my spine.”', who: 'Hannah', role: 'Dental hygienist' },
        { p: '“Less bulk in the seat lets me scoot close so I see in the mouth, preventing me from leaning over, killing my lower back.”', who: 'Melissa F.', role: 'Dental hygienist, 18 yrs' },
        { p: '“With the tilt and open hip angle I stay balanced for hours. Longer sessions, less fatigue, better work.”', who: 'Ali', role: 'Tattoo artist' }
      ];
      items = items.slice(0, 3);
      var wrap = el('div', 'pn-quotes');
      wrap.innerHTML = '<p class="pn-quotes__k"><span class="stars">★★★★★</span> 4.9 / 5 · verified buyers</p><div class="pn-quotes__row">' +
        items.map(function (q) { return '<div class="pn-quote"><p>' + q.p + '</p><small><b>' + q.who + '</b> · ' + q.role + '</small></div>'; }).join('') + '</div>';
      var host = bx.querySelector('.paylogos') || bx.querySelector('.spdp-addons') || qty;
      after(host, wrap);
    }

    /* 6. sticky Add-to-cart on phones from the moment the gallery scrolls away (pn-spdp.js waits for the main button) */
    var sticky = root.querySelector('.spdp-sticky'), mainBtn = root.querySelector('.qtyrow .pnbtn[data-spdp-atc]'), gallery = root.querySelector('.gallery');
    if (sticky && mainBtn) {
      var tick = false;
      var upd = function () {
        tick = false;
        if (!mq.matches) { sticky.classList.remove('pn-stick'); return; }
        var r = mainBtn.getBoundingClientRect(), g = gallery ? gallery.getBoundingClientRect() : { bottom: 0 };
        var btnInView = r.top < window.innerHeight - 70 && r.bottom > 0;
        sticky.classList.toggle('pn-stick', g.bottom < 60 && !btnInView);
      };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; setTimeout(upd, 60); } }, { passive: true });
      upd();
    }
  });
})();
